import { render, staticRenderFns } from "./BHero.vue?vue&type=template&id=59f3a443&"
import script from "./BHero.vue?vue&type=script&lang=js&"
export * from "./BHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports